import React, { PureComponent } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import { Alert, Button, Col, Form, FormGroup, Input, Row } from 'reactstrap'
import NewHeader from '../../components/layout/NewHeader/NewHeader'
import { FormattedMessage, injectIntl } from 'react-intl'
import { MailIcon, Container, Description, Form as StyledForm, InfoBox, InfoText } from './ContactStyledComponents'
import PropTypes from 'prop-types'

class Contact extends PureComponent {
  constructor() {
    super()
    this.recaptchaRef = React.createRef()
    this.onChange = this.onChange.bind(this)
    this.validate = this.validate.bind(this)
    this.state = {
      formName: '',
      formPhone: '',
      formNameErr: false,
      formPhoneErr: false,
      captchaValid: false
    }
  }

  handleNameChange = e => {
    this.setState({
      formName: e.target.value
    })
  }

  handleNameOnBlur = () => {
    const { formName } = this.state
    if (/\d+/.test(formName)) {
      this.setState({
        formNameErr: true
      })
    } else {
      this.setState({
        formNameErr: false
      })
    }
  }

  handlePhoneChange = e => {
    this.setState({
      formPhone: e.target.value
    })
  }

  handlePhoneOnBlur = () => {
    const { formPhone } = this.state
    if (!/^\d+$/.test(formPhone)) {
      this.setState({
        formPhoneErr: true
      })
    } else {
      this.setState({
        formPhoneErr: false
      })
    }
  }

  onChange(value) {
    this.setState(
      {
        captchaValid: true
      },
      () => {
        document.getElementById('submitformButton').click()
      }
    )
  }

  validate(e) {
    const { formName, formPhone, captchaValid } = this.state
    if (/\d+/.test(formName)) {
      e.preventDefault()
    } else if (!/^\d+$/.test(formPhone)) {
      e.preventDefault()
    } else if (!captchaValid) {
      e.preventDefault()
      this.recaptchaRef.current.execute()
    }
  }

  render() {
    const { breadcrumb, intl, match } = this.props
    const { formNameErr, formPhoneErr } = this.state
    return (
      <React.Fragment>
        <form name="contact" netlify hidden data-netlify-recaptcha action="/hausmart/contact/success">
          <input type="text" name="name" id="name" placeholder="Name" />
          <input type="email" name="email" id="email" placeholder="Email" />
          <input type="text" name="company" id="company" placeholder="Company" />
          <input type="phone" name="phone" id="phone" placeholder="Phone number" />
          <input type="textarea" name="message" id="message" placeholder="Message" />
          <div name="reCaptcha" netlify-recaptcha></div>
        </form>
        <NewHeader breadcrumbTitle={breadcrumb}>
          <h1 className="text-center">
            <FormattedMessage id="contact.header" />
          </h1>
        </NewHeader>
        <Container className="contact">
          <Row className="contact-row">
            <Col md={{ size: 5, offset: 1 }}>
              <h1 className={'text-weight--bold'}>
                <FormattedMessage id="contact.getInTouch" />
              </h1>
              <Description>
                <FormattedMessage id="contact.informationHeader" />
              </Description>
              <div className={'contact-info'}>
                <InfoBox>
                  <a href="mailto:info@hausmart.com ">
                    <MailIcon />
                    <InfoText>info@hausmart.com </InfoText>
                  </a>
                </InfoBox>
              </div>
            </Col>
            <Col md={{ size: 5 }} className="contact-form-wrapper">
              <StyledForm>
                <h2 className={'text-weight--bold'}>
                  <FormattedMessage id="contact.dontBeShy" />
                </h2>
                {match && match.params.status === 'success' && (
                  <Alert color="success">
                    <FormattedMessage id="contact.thanksForMessage" />
                  </Alert>
                )}
                <Form name="contact" method="post" action="/hausmart/contact/success" onSubmit={this.validate}>
                  <input type="hidden" name="form-name" value="contact" arial-hidden="true" required />
                  <FormGroup>
                    <Input
                      onChange={this.handleNameChange}
                      onBlur={this.handleNameOnBlur}
                      type="text"
                      name="name"
                      aria-label={intl.formatMessage({ id: 'contact.name' })}
                      id="name"
                      placeholder={intl.formatMessage({ id: 'contact.name' })}
                      required
                    />
                    {formNameErr && (
                      <Alert color="danger">
                        <small>
                          <FormattedMessage id="contact.invalidName" />
                        </small>
                      </Alert>
                    )}
                  </FormGroup>
                  <FormGroup>
                    <Input
                      type="email"
                      name="email"
                      aria-label={intl.formatMessage({ id: 'contact.email' })}
                      id="email"
                      placeholder={intl.formatMessage({ id: 'contact.email' })}
                      required
                    />
                  </FormGroup>
                  <FormGroup>
                    <Input
                      type="text"
                      name="company"
                      aria-label={intl.formatMessage({
                        id: 'contact.company'
                      })}
                      id="company"
                      placeholder={intl.formatMessage({
                        id: 'contact.company'
                      })}
                      required
                    />
                  </FormGroup>
                  <FormGroup>
                    <Input
                      onChange={this.handlePhoneChange}
                      onBlur={this.handlePhoneOnBlur}
                      type="phone"
                      name="phone"
                      aria-label={intl.formatMessage({
                        id: 'contact.phoneNumber'
                      })}
                      id="phone"
                      placeholder={intl.formatMessage({
                        id: 'contact.phoneNumber'
                      })}
                      required
                    />
                    {formPhoneErr && (
                      <Alert color="danger">
                        <small>
                          <FormattedMessage id="contact.invalidPhoneNumber" />
                        </small>
                      </Alert>
                    )}
                  </FormGroup>
                  <FormGroup>
                    <Input
                      rows="4"
                      type="textarea"
                      name="message"
                      id="message"
                      placeholder={intl.formatMessage({
                        id: 'contact.message'
                      })}
                      aria-label={intl.formatMessage({
                        id: 'contact.message'
                      })}
                      required
                    />
                  </FormGroup>
                  <Button color="secondary" size="lg" block id="submitformButton">
                    <FormattedMessage id="contact.send" />
                  </Button>
                  <ReCAPTCHA
                    name="reCaptcha"
                    netlify-recaptcha="true"
                    ref={this.recaptchaRef}
                    size="invisible"
                    onChange={this.onChange}
                    // sitekey='6LegaHUUAAAAAFUhWXewdszDGsC5yta8WrTuJIPL'
                    sitekey="6Lchg3UUAAAAACUdWGqDtq3I0XBpdq2lD-OPA0_F"
                  />
                </Form>
              </StyledForm>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    )
  }
}

Contact.propTypes = {
  breadcrumb: PropTypes.string,
  intl: PropTypes.object.isRequired,
  match: PropTypes.object
}

export default injectIntl(Contact)
